/**
 * @generated SignedSource<<88f279dbe5ccdf9215c75bd7dca3235f>>
 * @relayHash 9c0afe40300e5013e32bbea6173aea1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5

import type { ConcreteRequest } from 'relay-runtime';
export type usePreloadCommentButtonQuery$variables = {
  pageId: string;
};
export type usePreloadCommentButtonQuery$data = {
  readonly comments: {
    readonly count: number | null;
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly location: {
        readonly inlineMarkerRef?: string | null;
        readonly type: string;
      };
    } | null> | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly fabricEditorSupported: boolean | null;
        } | null;
      };
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
    } | null> | null;
  } | null;
};
export type usePreloadCommentButtonQuery = {
  response: usePreloadCommentButtonQuery$data;
  variables: usePreloadCommentButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ALL"
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "UNRESOLVED"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "count"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    }
  ],
  "type": "InlineComment"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "pageId"
    }
  ],
  "concreteType": "PaginatedContentListWithChild",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "editor"
            }
          ],
          "concreteType": "PaginatedJsonContentPropertyList",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            {
              "concreteType": "JsonContentProperty",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "key"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                }
              ]
            }
          ],
          "storageKey": "properties(key:\"editor\")"
        },
        {
          "concreteType": "ContentMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
              "kind": "LinkedField",
              "name": "frontend",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fabricEditorSupported"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePreloadCommentButtonQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePreloadCommentButtonQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      (v6/*: any*/)
    ]
  },
  "params": {
    "cacheID": "9c0afe40300e5013e32bbea6173aea1d",
    "id": "06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5",
    "metadata": {},
    "name": "usePreloadCommentButtonQuery",
    "operationKind": "query",
    "text": "query usePreloadCommentButtonQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ALL){count,nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}}}},content(id:$pageId){nodes{id,properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}}"
  }
};
})();

(node as any).hash = "213bd75259a759693c19bec62abadf60";

export default node;
